import { gql } from '@apollo/client';
import { WORKING_STUDENT_FRAGMENT } from './query';

export const ANSWER_WORKING_STUDENT = gql`
  mutation answerWorkingStudent($input: AnswerWorkingStudentInput!) {
    answerWorkingStudent(input: $input) {
      questions {
        id
        status
      }
      profile {
        ...WorkingStudent
      }
    }
  }
  ${WORKING_STUDENT_FRAGMENT}
`;
